<div class="page-container page-containers content-w-98">
  <div class="page-head">
    <div>
      <div class="page-title">
        <span class="headerName">{{ headerData!.materialName }}</span>
      </div>
    </div>
  </div>
  <div
    *ngrxLet="{
      dataLoaded: (sharedFacade.isLoaded$ | async),
      isClearSearch: (sharedFacade.isClearSearch$ | async)
    } as sharedData"
  >
    <div class="row" [ngClass]="{ 'disabled-project': packConversionList?.isLockProject }">
      <div class="col-md-12">
        <piqet-angular-portlet
          [columnDefs]="packConversionList?.isCostTurnOff ? columnDefs : costColumnDefs"
          [frameworkComponents]="frameworkComponents"
          [headerBtn]="'Add component detail'"
          [hideSideBar]="isHideSideBar"
          [gridData]="packConversionList?.conversionList"
          [class]="'fixedHeight'"
          [searchInputSize]="true"
          [createAccess]="showEdit"
          [pageNo]="$any(packConversionList?.conversionList)?.draw"
          (openBtnModal)="
            addMatierialModal(scenarioId, 0, false, 'Add material and conversion details')
          "
          [isClearSearch]="sharedData.isClearSearch"
          [gridName]="gridNameConversion"
          [eleId]="'component-detail'"
        ></piqet-angular-portlet>
      </div>
    </div>
  </div>
  <piqet-angular-navigation-button [config]="navigationConfig"> </piqet-angular-navigation-button>
</div>
